import React from 'react';

const InfoIcon = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.75" y="0.75" width="18.5" height="18.5" rx="9.25" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M9.16602 4.98633H10.8271L10.6904 11.5898H9.30957L9.16602 4.98633ZM8.94727 13.9756C8.94727 13.3398 9.37109 12.9229 10.0068 12.9229C10.6357 12.9229 11.0527 13.3398 11.0527 13.9756C11.0527 14.5977 10.6357 15.0146 10.0068 15.0146C9.37109 15.0146 8.94727 14.5977 8.94727 13.9756Z"
      fill="currentColor"
    />
  </svg>
);

export default InfoIcon;
